<template lang="pug">
.ticket(v-if="ticket")
  .ticket__desc
    .desc_title
      .tit(v-if="ticket.code") Код {{ ticket.code }}
      .tit(v-if="!ticket.code") Билет
      a.for-ticket(v-if="check(ticket)",
        @click="returnTicket()", href="#")
        i
        | &nbsp;вернуть
      a(v-if="!ticket.code", @click="cancelTicket()", href="#")
        icon(name="close")
    .desc_row
      .col
        .key ФИО
        .value {{ ticket.fio }}
    .desc_row
      .col
        .key Вагон
        .value {{ ticket.carNumber }}
      .col
        .key Место
        .value {{ ticket.places }}
      .col
        .key Дополнительная информация
        .value {{ ticket.additionalTerms }}
    .desc_row(v-if="!external")
      .col
        .key Стоимость
        .value {{ ticket.price | price }} р.
      .col
        .key Справочно-информационные услуги
        .value {{ ticket.commission | price }} р.
    .desc_row(v-if="ticket.remoteCheckInAvailable")
       label.checkbox
          input(type="checkbox", v-model="er", @click="changeEr")
          span.checkbox__text Электронная регистрация

  popup-return(v-if="showReturn", :orderId="orderId", :ticket="ticket", :type="'trains'",
    @close="showReturn = false", @onReturn="update()")
  popup-cancel(v-if="showCancel", :orderId="orderId", :ticketId="ticket.id", :type="'trains'",
    @close="showCancel = false", @onCancel="update()")

  popup-er(v-if="removeEReg",
    :orderId="orderId",
    :ticketId="ticket.id",
    :type="'ticket'",
    :status="0",
    @close="removeEReg = false",
    @onCancel="update()")

  popup-er(v-if="addEReg",
    :orderId="orderId",
    :ticketId="ticket.id",
    :type="'ticket'",
    :status="1",
    @close="addEReg = false",
    @onCancel="update()")

</template>

<script>
import popupReturn from '@/components/popups/return.vue';
import popupCancel from '@/components/popups/cancel.vue';
import popupEr from '@/components/popups/EReg.vue';
import Icon from '@/components/Icons.vue';
export default {
  props: ['ticket', 'orderId', 'external'],
  components: {
    Icon,
    popupReturn,
    popupCancel,
    popupEr,
  },
  data: () => ({
    showReturn: false,
    showCancel: false,
    addEReg: false,
    removeEReg: false,
    er: false,
  }),
  mounted() {
    this.er = !!this.ticket.remoteCheckIn;
  },
  methods: {
    update() {
      this.$emit('update');
      this.showReturn = false;
      this.showCancel = false;
    },

    returnTicket() {
      this.showReturn = true;
    },

    cancelTicket() {
      this.showCancel = true;
    },

    check(ticket) {
      if (ticket.code && !(ticket.isUsed)
        && this.getDisabled(ticket.date)
        && parseInt(ticket.price, 10) > 0) {
        return true;
      }
      return false;
    },

    getDisabled(time) {
      return Math.floor(new Date(time).getTime() / 1000) > Math.floor(Date.now() / 1000);
    },

    changeEr() {
      if (this.er === false) {
        this.addEReg = true;
      } else {
        this.removeEReg = true;
      }
    },
  },
};
</script>
<style lang="scss">
.for-ticket {
  display: flex;
  align-items: center;
}
.desc_title {
  i {
    background: url('../../../../common/assets/img/cancel_red.png') no-repeat;
    width: 15px;
    height: 8px;
  }
}
</style>>
